//To check if URL is external
export const isExternalUrl = (url) => {
  try {
    const link = new URL(url);
    return link.origin !== window.location.origin; // Check if the origin differs from the current site's origin
  } catch (e) {
    return false; // If the URL is invalid, return false
  }
};

//To fetch value from variables
export const getCssVariable = (variable: string): string => {
  return getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
};

export function highlightBracketedText(text:string , fontWeight:string) {
  return text.replace(/\(\((.*?)\)\)/g, `<span class="red-text ${fontWeight}">$1</span>`)
}
export function highlightUnderscoreText(title:string) {
  
  return title.replace(/__([^_]+)__/g, '<span class="font-medium">$1</span>');
}